import { render, staticRenderFns } from "./StationView.vue?vue&type=template&id=62cd0f3e&"
import script from "./StationView.vue?vue&type=script&lang=js&"
export * from "./StationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports